import { render } from "./TheRfidList.vue?vue&type=template&id=8453a220"
import script from "./TheRfidList.vue?vue&type=script&lang=js"
export * from "./TheRfidList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__